import { Container, Row, Col, Nav, Tab} from "react-bootstrap"
import { ProjectsTimeline } from "./ProjectsTimeline"
import projImgICNF from "../assets/img/icnf-proj.png"
import projImgOneX from "../assets/img/onex-proj.png"
import projImg3CA from "../assets/img/3CA-proj.png"
import projImgUniAI from "../assets/img/ai_uni-proj.png"
import projImgUniCurso from "../assets/img/ubi-proj.png"

export const Projects = () => {
    const work_projects = [
        {
            title: "ICNF",
            technologies: "OutSystems, JS, CSS3",
            description: "Portuguese government administration body, Instituto da Conservação da Natureza e das Florestas' system that integrates applications to simplify and make processes quicker.",
            timePeriod: "2021 - 2022",
            imgUrl: projImgICNF
        },
        {
            title: "One-X",
            technologies: "Laravel, jQuery, MySQL",
            description: "Excell Communications system that allows management of a company, from ticket management, to finance and human resources.",
            timePeriod: "2022 - 2024",
            imgUrl: projImgOneX
        }
    ]

    const work_projects2 = [
        {
            title: "StarMountain",
            technologies: "Golang, BPMN, NoSQL, Redis, API Development",
            description: "End-to-end SaaS for traceability of medicinal cannabis production chain, in order to make the processes the most efficient and transparent for regulatory entities. Has CRM and SRM integration, allowing the the management detail level to be as granular as desired.",
            timePeriod: "2024 - Present day",
            imgUrl: projImgOneX
        }
    ]

    const uni_projects = [
        {
            title: "Web Computing Degree",
            technologies: "Web Computing Degree",
            description: "Web-based Computer Science, with a special focus on the relation between the applications and services developed and their design.",
            timePeriod: "2018 - 2021",
            imgUrl: projImgUniCurso
        }, 
        {
            title: "3CA Management System and Blog",
            technologies: "PHP, HTML 5, CSS3",
            description: "System that allows management of 3CA's room at UBI, requests to use the room and a blog to share information.",
            timePeriod: "2021",
            imgUrl: projImg3CA
        }
    ]

    const personal_projects = [
        {
            title: "Bright Lisbon Agency",
            technologies: "React, Node.js, MongoDB",
            description: "Professional website for Bright Lisbon Agency, the first Junior Enterprise in Communications in Portugal. Features multiple sections including services (video production, graphic design, motion graphics), team, portfolio and recruitment, built with a modern full-stack architecture.",
            timePeriod: "2025",
            imgUrl: projImgOneX,
            link: "https://brightlxagency.com/"
        }
    ]

    const uni_projects2 = [
        {
            title: "Computer Science and Engineering MSc",
            technologies: "Computer Science and Engineering MSc",
            description: "Computer Science and Engineering goal was to develop a solid and outstanding background in Computer Science, fortifying the Full Stack knowledge aquired during previous course.",
            timePeriod: "2021 - 2024",
            imgUrl: projImgUniCurso
        },
        {
            title: "Process Automation using Artificial Intelligence",
            technologies: "Python, Machine Learning",
            description: "Development of A.I. module that reads history data of tickets and allocates the best field tech to solve the problems.",
            timePeriod: "2024",
            imgUrl: projImgUniAI
        }
    ]
    
    return (
        <section className="project" id="projects">
            <Container>
                <Row>
                    <Col>
                        <h2>Experience</h2>
                        <p>Here you can find my developing experience, from professional Work to my University Journey and Personal Projects.</p>
                        <Tab.Container id="projects-tabs" defaultActiveKey="first-project">
                            <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                                <Nav.Item>
                                    <Nav.Link eventKey="first-project">Work</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="second-project">University</Nav.Link>
                                </Nav.Item>
                                <Nav.Item>
                                    <Nav.Link eventKey="third-project">Personal</Nav.Link>
                                </Nav.Item>
                            </Nav>

                            <Tab.Content>
                                <Tab.Pane eventKey="first-project">
                                <Row>
                                    <ProjectsTimeline projectsArray={work_projects} moduleNumber="1"/>
                                    <ProjectsTimeline projectsArray={work_projects2} moduleNumber="2"/>
                                </Row>
                            </Tab.Pane>
                            <Tab.Pane eventKey="second-project">
                                <Row>
                                    <ProjectsTimeline projectsArray={uni_projects} moduleNumber="1"/>
                                    <ProjectsTimeline projectsArray={uni_projects2} moduleNumber="2"/>
                                </Row>
                            </Tab.Pane>
                            <Tab.Pane eventKey="third-project">
                                <Row>
                                    <ProjectsTimeline projectsArray={personal_projects} moduleNumber="1"/>
                                </Row>
                            </Tab.Pane>
                            </Tab.Content>
                        </Tab.Container>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}